import { INumericValueColor } from "./color/provider"
import { SoilAnalysisType, SoilCategory, SoilP2O5Method, SoilTypeId, SsmClassId, SubsoilTypeId } from "./generated/enums"
import { IOmniaService } from "./types"

/// <reference path="soil/colors/olsen.ts" />

export interface ISoilType {
    SoilTypeId: number
    Name: string
}

export interface ISubsoilType {
    SubsoilTypeId: number
    Name: string
}

export enum SoilUnit {
    Ppm = 0,
    Index = 1,
    KgHa = 2,
    Morgan = 3,
    Mg100g = 4
}

export interface ISoilUnitService extends ISoilUnitConfig {
}

export interface ISoilUnitConfig {
    soil: SoilUnit
    nitrogen: SoilUnit
}

export interface ISoilTypeService {

    getSoilClassification(soilTypeId: SoilTypeId, subsoilTypeId: SubsoilTypeId): SoilCategory

}


export interface ILaboratory {
    LaboratoryId: number
    Name: string
}


export interface IGenericAnalysis {

    AnalysisNumber?: string

    LaboratoryId?: number
    Laboratory?: ILaboratory

    HoldingId: number

    FieldReference?: string
    PlotReference?: string

    SamplingDate: Date
    CreatedOn?: Date

    GridSample?: boolean

    Allocations: IGenericAnalysisAlloc[]

    IsValid?: boolean

    Location?: string

}


export interface IGenericAnalysisAlloc {
    FieldId: number
    ZoneId?: number
    ZoneAlloc?: boolean
}


export interface ISoilAnalysis extends IGenericAnalysis {

    SoilAnalysisId: number

    Type: SoilAnalysisType

    PlotReference?: string
    FieldReference?: string

    FirstYear: number

    CalculatedAverage?: boolean
    TerraMap?: boolean

    P2O5?: number
    K2O?: number
    MgO?: number
    CaO?: number
    SO3?: number

    TotalP2O5?: number
    TotalK2O?: number
    TotalMgO?: number
    TotalCaO?: number

    Sodium?: number
    Copper?: number
    Boron?: number
    Zinc?: number
    Molybdenum?: number
    Iron?: number
    Manganese?: number

    P2O5Method?: SoilP2O5Method

    OrganicMatter?: number
    WaterpH?: number
    SoilCEC?: number
    ZoneAnalysis: boolean

    Sand?: number
    Silt?: number
    Clay?: number

    SoilHealthIndex?: number
    CO2BurstIndex?: number
    CO2Burst?: number

    Allocations: ISoilAnalysisAlloc[]
    Interpretations?: ISoilInterpretation[]

}

export interface ISoilAnalysisAlloc extends IGenericAnalysisAlloc {

    SoilAnalysisAllocId: number
    SoilAnalysisId: number
    ZoneAlloc: boolean
}

export interface IPcnAnalysis extends IGenericAnalysis {

    PcnAnalysisId: number

    FirstYear: number

    Location?: any

    EggsPerGram?: number
    CystsPer100Gram?: number

    Allocations: IPcnAnalysisAlloc[],

}

export interface IPcnAnalysisAlloc extends IGenericAnalysisAlloc {

    PcnAnalysisAllocId: number
    PcnAnalysisId: number
}

export interface ISoilInterpretation {
    SoilInterpretationId: number
    SoilAnalysisId: number
    PropertyName: string
    Comment: string
}

export interface ISoilAnalysisColor extends INumericValueColor {
    Index?: number
    Label?: string
}


/**
 * Describes an entry in the SSM classification
 */
export interface SsmClassification {

    /** Property name on the analysis object */
    readonly Property: string

    /** Class id */
    readonly ClassId: SsmClassId

    /** Minimum value - all values greater than or equal to this minimum, and lower than that of the next class, are in this class */
    readonly MinValue: number

    /** Default comment/interpretation for values in this class */
    readonly DefaultComment: string

}

export interface SharedSoilService extends IOmniaService {

    getSoilAnalyses(type?: SoilAnalysisType, terramap?: boolean): ISoilAnalysis[]
    getPcnAnalysis(): IPcnAnalysis[]

}
